import { render, staticRenderFns } from "./NSPlayer.vue?vue&type=template&id=c1da80d2&scoped=true"
import script from "./NSPlayer.vue?vue&type=script&lang=js"
export * from "./NSPlayer.vue?vue&type=script&lang=js"
import style0 from "./NSPlayer.vue?vue&type=style&index=0&id=c1da80d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1da80d2",
  null
  
)

export default component.exports